import './search-form';
import './backtoptop';
import './swiper';
import './menu-item-image';
import './formations-accordion';
import './formations-steps';
import './numbers-count';
import './modal';
import './pages-accordion';